// extracted by mini-css-extract-plugin
export var active = "_2i-2";
export var highlight = "_2i-1";
export var highlightLayer = "_2i-0";
export var issuePopover = "_2i-3";
export var statusIcon = "_2i-4";